import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './auth.component';
import { LoginComponent } from './components/login/login.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { GuestGuard } from '../core/guards/guest/guest.guard';

const routes: Routes = [
  {
    path: 'auth', // Base path para "auth"
    component: AuthComponent,
    children: [
      {
        path: 'login', // Ruta para "auth/login"
        component: LoginComponent,
        canActivate: [GuestGuard],
        data: { returnUrl: window.location.pathname },
      },
      {
        path: 'reset-password',
        component: ForgotPasswordComponent,
        canActivate: [GuestGuard],
      },
      {
        path: 'forgot-password/:random',
        component: ResetPasswordComponent,
        canActivate: [GuestGuard],
      },
      {
        path: '**', // Redirige cualquier ruta inválida bajo "auth"
        redirectTo: 'login',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
